import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CalcHouse icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CalcHouse } from '@sravni/design-system-icons'
 *
 * <CalcHouse />
 * ```
 */
var CalcHouse = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CalcHouse", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m1.736 6 8.206-4.796a1.646 1.646 0 0 1 1.589 0L19.736 6", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M13.07 16h2.5M13.07 13.5h2.5M3.236 11h15M3.236 5.457v11.086c0 1.081.876 1.957 1.957 1.957H16.28c1.08 0 1.956-.876 1.956-1.957V5.457m-12-1.957h9M13.236 7.25h2.5M5.736 7.25h2.5M6.986 8.5V6M6.103 13.867l1.766 1.766M6.103 15.633l1.766-1.766M10.736 3.5v15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CalcHouse };
//# sourceMappingURL=CalcHouse.js.map
